import { useLocation } from "react-router-dom";
import styled from "styled-components";
import React, { useState, useCallback } from "react";
import Logo from "./components/Logo";
import ConnectButton from "./components/ConnectButton"


export default function NavBar() {

  const location = useLocation();
  
  return (
    <StyledTopBar>
      <StyledTopBarInner>
        <StyledLeftMenuWrapper>
          <Logo/>
        </StyledLeftMenuWrapper>
        <div className="nav-center">{location.pathname === '/' ? 'Dashboard' : 'Market'}</div>
        <StyledRightMenuWrapper>
          <ConnectButton/>
        </StyledRightMenuWrapper>
      </StyledTopBarInner>
    </StyledTopBar>
  )
}

const StyledTopBar = styled.div`
  display:fixed;
  top:0;
  left:0;
  .nav-center{
    flex: 1;
    align-self: flex-start;
    height: 100%;    
    font-weight: 500;
    font-size: 20px;
    padding-left: 62px;
    padding-top: 3px;
    .nft-nav{
      display: flex;
      align-items: center; 
      min-width: 735px;
      .nav-item{
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;           
        & + .nav-item{
          margin-left: 40px;
        }
        &.true-active{
          color: #32DE86;
        }
        span{
          display: inline-block;
          width: 47px;
          height: 22px;
          font-weight: 400;
          font-size: 12px;
          line-height: 22px;
          text-align: center;
          color: #CAFF33;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 6px;
          margin-left: 4px;
        }
      }
      .soon-item{
        color: rgba(255, 255, 255, 0.3)
        
      }

    }
  }
`;

const StyledTopBarInner = styled.div`
  width: 100%;
  display:flex;
  box-sizing:border-box;
  justify-content: space-between;
  align-items: center;  
  padding: 28px 30px;
`;

const StyledLeftMenuWrapper = styled.div`  
  display: flex;
  align-items: center;
`
const StyledRightMenuWrapper = styled.div`  
    
`
